module.exports = __webpack_public_path__ + "static/media/tv.eb5ef829.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/tv.svg
// module id = 1180
// module chunks = 0